module.exports = __webpack_public_path__ + "img/06.f7bfe4b4.jpg";